import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form';
import {
  renderFieldSelect, renderFieldCnpj, renderFieldText, renderFieldCep, renderFieldCheck,
  required, requiredSelect, validarApenasNumero, validarCNPJ
} from '../../util/inputs';
import { renderField } from '../../util/arraysUtil';
import adicionarDadosCteEncomenda from '../../actions/encomenda/adicionarDadosCteEncomenda';
import { tipoIndicadorContribuicaoIE } from '../../util/constantsUtil';
import { obterNaturezaOperacaoPadrao } from '../../util/cteUtil';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { getEmpresaSelecionada } from '../../util/empresaSelecionada';

export class AbaCte extends Component {

  constructor(props) {
    super(props);
    this.pesquisarPorCep = this.pesquisarPorCep.bind(this);
    this.handleSelecionarCidadeEmitenteAnterior = this.handleSelecionarCidadeEmitenteAnterior.bind(this);
  }

  componentDidMount() {
    this.aplicarPadroesIniciais();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.naturezasOperacoes !== this.props.naturezasOperacoes) {
      this.aplicarNaturezaOperacaoPadrao();
    }
  }

  obterRntrcEmpresaAtual() {
    // getEmpresaSelecionada() (sessionStorage) é a mesma fonte que a barra de
    // navegação usa para exibir a empresa atual — pode estar mais atualizada
    // do que state.empresaSelecionada (Redux), que só muda via dispatch.
    const empresaAtual = getEmpresaSelecionada() || this.props.empresaSelecionada;
    if (empresaAtual && empresaAtual.rntrc) {
      return empresaAtual.rntrc;
    }
    const empresaId = empresaAtual && empresaAtual.id;
    const encontrada = (this.props.empresasAutenticacao || []).find(e => e.id === empresaId);
    return encontrada ? encontrada.rntrc : null;
  }

  // Aplica os dois defaults (rntrc + natureza da operação) num único
  // dispatch de adicionarDadosCteEncomenda. Fazer em dispatches separados
  // (um logo após o outro) é um bug: o reducer substitui o objeto inteiro
  // a cada ADICIONAR_DADOS_CTE_ENCOMENDA e this.props só reflete o dispatch
  // anterior no próximo render — então o segundo dispatch usaria uma cópia
  // de dadosCteEncomenda anterior ao primeiro como base, apagando o campo
  // que ele acabou de preencher.
  aplicarPadroesIniciais() {
    const rntrcPadrao = !this.props.dadosCteEncomenda.rntrc ? this.obterRntrcEmpresaAtual() : null;
    const naturezaPadrao = !this.props.dadosCteEncomenda.naturezaOperacao.value
      ? obterNaturezaOperacaoPadrao(this.props.naturezasOperacoes)
      : null;

    if (!rntrcPadrao && !naturezaPadrao) return;

    if (rntrcPadrao) this.props.change('rntrc', rntrcPadrao);
    if (naturezaPadrao) this.props.change('naturezaOperacao', naturezaPadrao);

    this.props.adicionarDadosCteEncomenda({
      ...this.props.dadosCteEncomenda,
      ...(rntrcPadrao ? { rntrc: rntrcPadrao } : {}),
      ...(naturezaPadrao ? { naturezaOperacao: naturezaPadrao } : {})
    });
  }

  aplicarNaturezaOperacaoPadrao() {
    if (!this.props.dadosCteEncomenda.naturezaOperacao.value) {
      const padrao = obterNaturezaOperacaoPadrao(this.props.naturezasOperacoes);
      if (padrao) {
        this.props.change('naturezaOperacao', padrao);
        this.props.adicionarDadosCteEncomenda({ ...this.props.dadosCteEncomenda, naturezaOperacao: padrao });
      }
    }
  }

  atualizarEmitenteCteAnterior(campos) {
    this.props.adicionarDadosCteEncomenda({
      ...this.props.dadosCteEncomenda,
      emitenteCteAnterior: { ...this.props.dadosCteEncomenda.emitenteCteAnterior, ...campos }
    });
  }

  pesquisarPorCep(event) {
    const CEP = event.target.value.replace(/\D/g, '')
    this.atualizarEmitenteCteAnterior({ cep: event.target.value });
    if (CEP.length === 8) {
      const url = `${URL}/cep/public/${CEP}`
      axios.get(url, SLOW_REQUEST_CONFIG).then((resp) => {
        if (resp.status === 200) {
          this.props.change('logradouro', resp.data.logradouro);
          this.props.change('complemento', resp.data.complemento);
          this.props.change('bairro', resp.data.bairro);
          this.atualizarEmitenteCteAnterior({
            cep: event.target.value,
            logradouro: resp.data.logradouro,
            complemento: resp.data.complemento,
            bairro: resp.data.bairro
          });
        }
      })
    }
  }

  handleSelecionarCidadeEmitenteAnterior(cidade) {
    this.atualizarEmitenteCteAnterior({ cidade });
  }

  tipoServicoNormalSelecionado() {
    const tipoServicoCte = this.props.dadosCteEncomenda.tipoServicoCte;
    return !!(tipoServicoCte && tipoServicoCte.value === 'NORMAL');
  }

  handleSelecionarTipoServico(tipoServicoCte) {
    const dados = { ...this.props.dadosCteEncomenda, tipoServicoCte };
    if (tipoServicoCte && tipoServicoCte.value === 'NORMAL' && dados.habilitadoChaveCteAnterior) {
      dados.habilitadoChaveCteAnterior = false;
      this.props.change('habilitadoChaveCteAnterior', false);
    }
    this.props.adicionarDadosCteEncomenda(dados);
  }

  exibirCamposEmpresaAnterior() {
    return (
      <div>
        <div className="form-row mt-2">
          <div className="col-12 col-sm-6 col-md-6">
            <Field name="nomeFantasia"
              css='form-control'
              validate={[required]}
              component={renderFieldText}
              onChange={(e) => this.atualizarEmitenteCteAnterior({ nomeFantasia: e.target.value })}
              label="Nome Fantasia"/>
          </div>
          <div className="col-12 col-sm-6 col-md-6">
            <Field name="razaoSocial"
              css='form-control'
              validate={[required]}
              component={renderFieldText}
              onChange={(e) => this.atualizarEmitenteCteAnterior({ razaoSocial: e.target.value })}
              label="Razão Social"/>
          </div>
        </div>
        <div className="form-row">
          <div className="col-12 col-sm-4 col-md-4">
            <Field name="numeroCnpj"
              css='form-control'
              validate={[required, validarCNPJ]}
              component={renderFieldCnpj}
              onChange={(e) => this.atualizarEmitenteCteAnterior({ numeroCnpj: e.target.value })}
              label="Número CNPJ"/>
          </div>
          <div className="col-12 col-sm-3 col-md-3">
            <Field name="inscricaoEstadual"
              css='form-control'
              component={renderFieldText}
              onChange={(e) => this.atualizarEmitenteCteAnterior({ inscricaoEstadual: e.target.value })}
              label="Inscrição Estadual"/>
          </div>
        </div>
      </div>
    )
  }

  exibirCamposEnderecoAnterior() {
    return (
      <div>
        <div className="form-row mt-2">
          <div className="col-12 col-sm-4 col-md-4">
            <Field name="cep" type="text" validate={[required]} component={renderFieldCep} label="CEP:"
              css="form-control" readOnly={false} onChange={e => this.pesquisarPorCep(e)}/>
          </div>
          <div className="col-12 col-sm-4 col-md-4">
            <Field name='tipoIndicadorContribuicaoIE'
              options={tipoIndicadorContribuicaoIE.map(elemento => ({
                descricao: elemento.label,
                nome: elemento.value
              }))}
              placeholder='Selecione...'
              onChange={(e) => this.atualizarEmitenteCteAnterior({ tipoIndicadorContribuicaoIE: e })}
              component={renderFieldSelect}
              label='Indicador Contribuição:' validate={requiredSelect}/>
          </div>
        </div>
        <div className="form-row">
          <div className="col-12 col-sm-9 col-md-9">
            <Field name="logradouro" type="text" validate={[required]} component={renderField}
              label="Logradouro:"
              onChange={(e) => this.atualizarEmitenteCteAnterior({ logradouro: e.target.value })}
              css="form-control" readOnly={false}/>
          </div>
        </div>
        <div className="form-row">
          <div className="col-12 col-sm-4 col-md-4">
            <Field name="bairro" type="text" validate={[required]} component={renderField} label="Bairro:"
              onChange={(e) => this.atualizarEmitenteCteAnterior({ bairro: e.target.value })}
              css="form-control" readOnly={false}/>
          </div>
          <div className="col-12 col-sm-5 col-md-5">
            <Field name="complemento" type="text" validate={[required]} component={renderField} label="Complemento:"
              onChange={(e) => this.atualizarEmitenteCteAnterior({ complemento: e.target.value })}
              css="form-control" readOnly={false} />
          </div>
          <div className="col-12 col-sm-9 col-md-3">
            <Field name="numero" type="text" validate={[required, validarApenasNumero]} component={renderField} label="Número:"
              onChange={(e) => this.atualizarEmitenteCteAnterior({ numero: e.target.value })}
              css="form-control" readOnly={false} />
          </div>
        </div>
        <div className="form-row">
          <div className="col-12 mt-2">
            <label>Cidade:</label>
          </div>
          <SelecaoCidadeAutocomplete name='informeCidadeEmitenteAnterior'
            selecionarCidade={this.handleSelecionarCidadeEmitenteAnterior}
            value={this.props.dadosCteEncomenda.emitenteCteAnterior && this.props.dadosCteEncomenda.emitenteCteAnterior.cidade}
          />
        </div>
      </div>
    )
  }

  preencherCamposEmitenteCteAnterior() {
    return (
      <>
        <div className="form-row">
          <div className="col-12 col-sm-6 col-md-6">
            <Field name="chaveCte" type="text" validate={[required]} component={renderField}
              label="Chave Cte:"
              css="form-control"
              onChange={(e) => this.atualizarEmitenteCteAnterior({ chaveCte: e.target.value })}
            />
          </div>
        </div>
        {this.exibirCamposEmpresaAnterior()}
        {this.exibirCamposEnderecoAnterior()}
      </>
    )
  }

  render() {
    return (
      <>
        <h3>Transmissão Cte</h3>
        <div className="form-row">
          <div className="col-12 col-sm-6 col-md-6">
            <Field name='tipoServicoCte'
              options={this.props.tiposServicos.map(elemento => ({
                descricao: elemento.valor,
                nome: elemento.chave
              }))}
              onChange={(e) => this.handleSelecionarTipoServico(e)}
              component={renderFieldSelect}
              label='Tipo Serviço:'
              placeholder='Selecione...' validate={requiredSelect}
              disabled={!this.props.usuarioVendeEncomendaComCte}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-6">
              <Field name="rntrc" type="text" validate={[required]} component={renderField}
                  label="Registro Nacional de Transportadores Rodoviários de Carga (RNTRC):"
                  css="form-control"
                  readOnly={!this.props.usuarioVendeEncomendaComCte}
                  onChange={(e) => this.props.adicionarDadosCteEncomenda({ ...this.props.dadosCteEncomenda, rntrc: e.target.value })}
              />
          </div>
        </div>
        <div className="form-row">
          <div className="col-12 col-sm-12 col-md-12">
            <Field name='naturezaOperacao'
              options={this.props.naturezasOperacoes.map(it => ({
                descricao: it.valor,
                nome: it.chave
              }))}
              component={renderFieldSelect}
              label="Natureza da Operação:"
              placeholder='Selecione...' validate={requiredSelect}
              onChange={(e) => this.props.adicionarDadosCteEncomenda({ ...this.props.dadosCteEncomenda, naturezaOperacao: e })}
              disabled={!this.props.usuarioVendeEncomendaComCte}
            />
          </div>
        </div>
        {!this.tipoServicoNormalSelecionado() && (
          <div className="form-row mt-2">
            <div className="col-12 col-sm-6 col-md-6">
              <Field name='habilitadoChaveCteAnterior' type="checkbox" component={renderFieldCheck}
                label="Habilitar Emitente Cte Anterior"
                css="form-check-input"
                readOnly={!this.props.usuarioVendeEncomendaComCte}
                onChange={(e) => this.props.adicionarDadosCteEncomenda({ ...this.props.dadosCteEncomenda, habilitadoChaveCteAnterior: e.target.checked })}
              />
            </div>
          </div>
        )}
        {this.props.dadosCteEncomenda.habilitadoChaveCteAnterior && !this.tipoServicoNormalSelecionado() ? (
          this.preencherCamposEmitenteCteAnterior()
        ) : (
          <div className="form-row">
            <div className="col-12 col-sm-6 col-md-6">
                <Field name="chaveNfe" type="text" validate={[required]} component={renderField}
                    label="Chave NF-e:"
                    css="form-control"
                    readOnly={!this.props.usuarioVendeEncomendaComCte}
                    onChange={(e) => this.props.adicionarDadosCteEncomenda({ ...this.props.dadosCteEncomenda, chaveNfe: e.target.value })}
                />
            </div>
          </div>
        )}
      </>
    )
  }
}

export const mapStateToProps = state => (
  {
    tiposServicos: state.opcoesFiltrosEmissaoesCte.tipoServicoCte,
    naturezasOperacoes: state.opcoesFiltrosEmissaoesCte.naturezasOperacoes,
    usuarioVendeEncomendaComCte: state.usuarioVendeEncomendaComCte,
    dadosCteEncomenda: state.dadosCteEncomenda,
    empresaSelecionada: state.empresaSelecionada,
    empresasAutenticacao: (state.authentication && state.authentication.empresas) || [],
    initialValues: {
      rntrc: state.dadosCteEncomenda.rntrc,
      tipoServicoCte: state.dadosCteEncomenda.tipoServicoCte,
      naturezaOperacao: state.dadosCteEncomenda.naturezaOperacao,
      chaveNfe: state.dadosCteEncomenda.chaveNfe,
      habilitadoChaveCteAnterior: state.dadosCteEncomenda.habilitadoChaveCteAnterior,
      chaveCte: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.chaveCte,
      nomeFantasia: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.nomeFantasia,
      razaoSocial: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.razaoSocial,
      numeroCnpj: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.numeroCnpj,
      inscricaoEstadual: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.inscricaoEstadual,
      tipoIndicadorContribuicaoIE: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.tipoIndicadorContribuicaoIE,
      cep: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.cep,
      logradouro: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.logradouro,
      complemento: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.complemento,
      bairro: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.bairro,
      numero: state.dadosCteEncomenda.emitenteCteAnterior && state.dadosCteEncomenda.emitenteCteAnterior.numero
    }
  });


export default connect(mapStateToProps, {
  adicionarDadosCteEncomenda
})(reduxForm({
  form: 'formularioCadastroEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaCte))
